
import { createSlice } from '@reduxjs/toolkit'
import { meld } from '../../lib/logboek';
const initialState = {
  // De korting op onderdeel 1 van de gekozen combinaties (L8b): het boekformulier rekent hem uit, de samenvatting toont hem.
  kortingEen: 0,
  // Wat de server voor elk onderdeel van een combinatie rekent, na de korting van de combinatie (besluit Martijn 11-10-2026):
  // { [idCombinations]: { prijs, extraproducten, sleutel } }. Gevuld door useCombinatieprijzen (lib/combinatieprijzen.js).
  combinatieprijzen: {},
  adult: 0,
  child: 0,
  kid: 0,
  baby: 0,
  toddler: 0,
  isGreaterThan10: {
    adult: false,
    child: false,
    kid: false,
    baby: false,
    toddler: false,
  },
  activityDataLoading: false,
  dateLoading: false,
  isBookNowOpen: false,
  totalCount: 0,
  selectedDate: '',
  selectedCategories: {},
  categoryList: [],
  reservType: {},
  time: '',
  reservGroup: {},
  reservationTypeDatas: [],
  freeTablesData: [],
  // De vrije begintijden per duur (timeValue -> tijden): welke duur past op de gekozen tijd (opdracht 2F, 11-10-2026).
  tijdenPerDuur: {},
  reservationGroupData: [],
  GuestDetailsData: [],
  extraProductData: [],
  selectedExtraProduct: [],
  transactionDetails: {},
  guestFields: [],
  combinationWidgetData: [],
  selectedCombination: [],
  addFields: [],
  reservationLang: '',
  ReservationDetail: null,
  OpeningHoursWidget: [],
  languageWords: {},
  isBackToHoreca: false,
  languageId: null,
  isOpenWidget: false,
  defaultLanguage: "",
  extraFieldsData: [],
  ActivityData: [],
  blockedDates: [],
  quantities: {},
  activityDuration: {},
  combinationList: [],
  AvailableLocationData: [],
  TotalAmountInclusiveVAT: 0,
  TotalVAT: 0,
  combinationQTY: {},
  combinationUpsaleProductsQTY: {},
  combinationUpsaleData: [],
  selectedCombinationUpsale: [],
  combinationTime: {},
  combinationDuration: {},

}
export const addActvitySlice = createSlice({
  name: 'Activity',
  initialState,
  reducers: {

    setGuestCount: (state, action) => {
      const { guestType, count } = action.payload;
      if (state[guestType] !== undefined) {
        state[guestType] = count;
      }
    },
    checkGuestLimit: (state, action) => {
      const { guestType, isGreaterThan10 } = action.payload;
      if (state.isGreaterThan10[guestType] !== undefined) {
        state.isGreaterThan10[guestType] = isGreaterThan10;
      }
    },
    toggleBookNowOpen: (state) => {
      state.isBookNowOpen = !state.isBookNowOpen;
    },
    updateTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    updateSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    updateSelectedCategory: (state, action) => {
      state.selectedCategories = action.payload;
    },
    updateReservationType: (state, action) => {
      state.reservType = action.payload;
    },
    updateCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
    updateActivityDuration: (state, action) => {
      state.activityDuration = action.payload;
    },
    updateTime: (state, action) => {
      state.time = action.payload;
    },
    updateReservationGroup: (state, action) => {
      state.reservGroup = action.payload;
    },
    setReservationTypeDatas: (state, action) => {
      state.reservationTypeDatas = action.payload;
    },
    setReservationGroupDatas: (state, action) => {
      state.reservationGroupData = action.payload;
    },
    setFreeTablesData: (state, action) => {
      state.freeTablesData = action.payload;
    },
    setTijdenPerDuur: (state, action) => {
      state.tijdenPerDuur = action.payload && typeof action.payload === "object" ? action.payload : {};
    },
    setGuestDetailsData: (state, action) => {
      state.GuestDetailsData = action.payload;
    },
    setExtraProductData: (state, action) => {
      state.extraProductData = action.payload;
    },
    setSelectedExtraProduct: (state, action) => {
      state.selectedExtraProduct = action.payload;
    },
    setTransactionDetails: (state, action) => {
      state.transactionDetails = action.payload;
    },
    setGuestFields: (state, action) => {
      state.guestFields = action.payload;
    },
    setCombinationWidgetData: (state, action) => {
      state.combinationWidgetData = action.payload;
    },
    setSelectedCombination: (state, action) => {
      meld("payload", action.payload)
      state.selectedCombination = action.payload;
    },
    setAddFields: (state, action) => {
      state.addFields = action.payload;
    },
    setReservationLang: (state, action) => {
      state.reservationLang = action.payload;
    },
    setReservationDetail: (state, action) => {
      state.ReservationDetail = action.payload;
    },
    SetUpateOpeningHours: (state, action) => {
      state.OpeningHoursWidget = action.payload
    },
    setLanguageWords: (state, action) => {
      state.languageWords = action.payload
    },
    setDateLoading: (state, action) => {
      state.dateLoading = action.payload
    },
    setIsBackToHoreca: (state, action) => {
      state.isBackToHoreca = action.payload
    },
    setLanguageID: (state, action) => {
      state.languageId = action.payload
    },
    setIsOpenWidget: (state, action) => {
      state.isOpenWidget = action.payload
    },
    updateDefaultLanguage: (state, action) => {
      state.defaultLanguage = action.payload;
    },
    setExtraFieldsData: (state, action) => {
      state.extraFieldsData = action.payload;
    },
    setActivityDataLoading: (state, action) => {
      state.activityDataLoading = action.payload;
    },
    setActivityData: (state, action) => {
      state.ActivityData = action.payload;
    },
    updateBlockedDates: (state, action) => {
      state.blockedDates = action.payload;
    },
    setQuantities: (state, action) => {
      state.quantities = action.payload;
    },
    setCombinationList: (state, action) => {
      state.combinationList = action.payload;
    },
    setAvailableLocationData: (state, action) => {
      state.AvailableLocationData = action.payload;
    },
    setTotalAmountInclusiveVAT: (state, action) => {
      state.TotalAmountInclusiveVAT = action.payload;
    },
    setTotalVAT: (state, action) => {
      state.TotalVAT = action.payload;
    },
    setKortingEen: (state, action) => {
      state.kortingEen = Number(action.payload) || 0;
    },
    // payload: { [idCombinations]: { prijs, extraproducten, sleutel } } erbij of vervangen; null als waarde = weg.
    setCombinatieprijzen: (state, action) => {
      const nieuw = { ...(state.combinatieprijzen || {}) };
      for (const [id, waarde] of Object.entries(action.payload || {})) {
        if (waarde == null) delete nieuw[id]; else nieuw[id] = waarde;
      }
      state.combinatieprijzen = nieuw;
    },
    setCombinationQTY: (state, action) => {
      state.combinationQTY =
        typeof action.payload === "function"
          ? action.payload(state.combinationQTY || {}) // Ensure state is an object
          : action.payload;
    },
    setCombinationUpsaleProductsQTY: (state, action) => {
      state.combinationUpsaleProductsQTY = action.payload
    },
    setCombinationUpsaleData: (state, action) => {
      state.combinationUpsaleData = action.payload
    },
    setSelectedCombinationExtraProduct: (state, action) => {
      state.selectedCombinationUpsale = action.payload;
    },
    setCombinationTime: (state, action) => {
      // payload: { id: idCombinations, value: timeString }
      state.combinationTime = { ...state.combinationTime, [action.payload.id]: action.payload.value };
    },
    setCombinationDuration: (state, action) => {
      // payload: { id: idCombinations, value: durationString }
      state.combinationDuration = { ...state.combinationDuration, [action.payload.id]: action.payload.value };
    },




  },
})
export const {
  setCombinationUpsaleProductsQTY,
  setCombinationUpsaleData,
  setSelectedCombinationExtraProduct,
  setGuestCount,
  checkGuestLimit,
  toggleBookNowOpen,
  updateTotalCount,
  updateSelectedDate,
  updateReservationType,
  updateTime,
  updateReservationGroup,
  setReservationTypeDatas,
  setFreeTablesData,
  setTijdenPerDuur,
  setReservationGroupDatas,
  setGuestDetailsData,
  setExtraProductData,
  setSelectedExtraProduct,
  setTransactionDetails,
  setGuestFields,
  setCombinationWidgetData,
  setSelectedCombination,
  setAddFields,
  setReservationLang,
  setReservationDetail,
  SetUpateOpeningHours,
  setQuantities,
  setLanguageWords,
  setDateLoading,
  setIsBackToHoreca,
  setLanguageID,
  setIsOpenWidget,
  updateDefaultLanguage,
  setExtraFieldsData,
  setActivityDataLoading,
  setActivityData,
  updateBlockedDates,
  updateActivityDuration,
  setCombinationList,
  setAvailableLocationData,
  setTotalAmountInclusiveVAT,
  setTotalVAT,
  setCombinationQTY,
  setKortingEen,
  setCombinatieprijzen,
  updateCategoryList,
  updateSelectedCategory,
  setCombinationTime,
  setCombinationDuration,
} = addActvitySlice.actions

export default addActvitySlice.reducer;